
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Layout from '@/components/Layout';
import MetaTags from '@/components/SEO/MetaTags';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import { sitemapSections } from '@/data/sitemapData';
import { FilterCategory } from '@/types/sitemap';
import { SitemapTable } from '@/components/sitemap/SitemapTable';
import { SitemapCTA } from '@/components/sitemap/SitemapCTA';

const Sitemap = () => {
  const [selectedFilter, setSelectedFilter] = useState<FilterCategory>('all');

  const filteredSections = sitemapSections.filter(section => {
    if (selectedFilter === 'all') return true;
    return section.category === selectedFilter;
  });

  return (
    <>
      <MetaTags 
        title="JUV Sitemap - Complete Navigation Map"
        description="Complete sitemap of all JUV pages organized by audience: Patients, Providers, Staff, and Platform utilities."
        keywords={['sitemap', 'navigation', 'juv pages', 'site map', 'website structure']}
      />
      <Layout>
        <div className="container mx-auto px-6 py-12 max-w-7xl">
          {/* Breadcrumb */}
          <Breadcrumb className="mb-8">
            <BreadcrumbList>
              <BreadcrumbItem>
                <BreadcrumbLink asChild>
                  <Link to="/">Home</Link>
                </BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                <BreadcrumbPage>Sitemap</BreadcrumbPage>
              </BreadcrumbItem>
            </BreadcrumbList>
          </Breadcrumb>

          {/* Header */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center mb-12"
          >
            <div className="text-6xl mb-6">🗺️</div>
            <h1 className="text-4xl md:text-5xl font-bold text-juv-deep-chestnut mb-6">
              Everything JUV has to offer — in one place.
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8">
              Navigate all patient, partner, staff, and platform pages below. Use this as your launchpad for exploring, booking, or building with JUV.
            </p>
          </motion.div>

          {/* Sitemap Table */}
          <SitemapTable 
            sections={sitemapSections}
            selectedFilter={selectedFilter}
            onFilterChange={setSelectedFilter}
          />

          {/* Final CTA Footer */}
          <SitemapCTA />
        </div>
      </Layout>
    </>
  );
};

export default Sitemap;
